import React, { useEffect, useState } from 'react'
import axios from 'axios'

import Panel from '../ui/Panel'
import ChallengeLangForm from './ChallengeLangForm'
import './challenges.css'

/*
 * TRANSLATIONS of one content record.
 *
 * GET admin/lang -> [{ LangID, LangName, UUID }]   (untouched)
 *
 * The editing flow is exactly the one that was here: one tab per language,
 * each tab holding a ChallengeLangForm that loads and saves that language on
 * its own (admin/challenges/challengelang/:id/:LangUUID). Only the tab strip
 * changed — Bootstrap's <Tabs> became token-styled buttons, so the tabs follow
 * the theme and stay usable at 390px.
 *
 * The active pane is keyed by the language UUID, which is what makes switching
 * language remount its form and re-run its own GET — the same request the
 * Bootstrap pane fired when it mounted.
 */

export default function ChallengeLang(props) {

  const [data,setData]=useState([])
  const [isLoading,setIsLoading]=useState(false)
  const [failed,setFailed]=useState(false)
  const [active,setActive]=useState('')

  useEffect(()=>{
    loadData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])

  const loadData=()=>{
    setIsLoading(true)
    setFailed(false)
    axios.get(process.env.REACT_APP_API_SERVER+'admin/lang',{
      headers: {
          'Authorization': 'Bearer '+sessionStorage.getItem("apiToken")
          }
      })
    .then(res=>{
     // console.log(res.data.results)
      setData(res.data.results)
      setIsLoading(false)

    }).catch(err=>{
        setIsLoading(false)
        setFailed(true)
        console.log(err)
    })
  }

  const rows=Array.isArray(data) ? data : []

  /* First language on arrival; never strand the strip on a language that the
     list no longer carries. */
  useEffect(()=>{
    if (rows.length===0) return
    const stillThere=rows.some(item=>String(item.UUID)===String(active))
    if (!stillThere) setActive(String(rows[0].UUID))
  },[rows,active])

  const current=rows.find(item=>String(item.UUID)===String(active))

  return (
    <Panel
      title={(props.IsChallenge==1 ? 'Challenge' : 'Article')+' Languages'}
      subtitle="Title and description per language"
    >

      {isLoading && (
        <div className="chx-sk">
          <div className="skeleton chx-sk-line"></div>
          <div className="skeleton chx-sk-line chx-sk-short"></div>
        </div>
      )}

      {!isLoading && failed && (
        <div className="chx-note chx-note-crit" role="alert">
          <span className="chx-note-text">Languages could not be loaded. Please try again.</span>
        </div>
      )}

      {!isLoading && !failed && rows.length===0 && (
        <div className="empty">No content languages have been set.</div>
      )}

      {!isLoading && !failed && rows.length>0 && (
        <>
          <div className="chx-tabs" role="tablist" aria-label="Languages">
            {rows.map(item=>(
              <button
                key={item.LangID}
                type="button"
                role="tab"
                className="chx-tab"
                aria-selected={String(item.UUID)===String(active)}
                onClick={()=>setActive(String(item.UUID))}
              >
                {item.LangName}
              </button>
            ))}
          </div>

          {current && (
            <ChallengeLangForm key={current.UUID} id={props.id} LangID={current.UUID}/>
          )}
        </>
      )}

    </Panel>
  )
}
